import { useState, Dispatch } from 'react';
import { Props } from './types';
import { Modal, Form, Button, Input, Space } from 'antd';
import { StyleTitulo, Detalhes } from './style';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { sendMenssageRequest } from '../../../../store/ducks/sendMenssages/actions';
import { loadRequest } from '../../../../store/ducks/atendimentos/actions';
import Swal from 'sweetalert2';
import { ExclamationCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { loadRequestUpdate } from '../../../../store/ducks/ocorrencia/actions';
import moment from 'moment';
import { maskCapitalized } from '../../../../utils/mask';

const ModalReabrirAtendimento: React.FC<Props> = ({ propriedades }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const [form] = Form.useForm();
  const { TextArea } = Input;

  const filter = useSelector((state: ApplicationState) => state.Atendimentos.filter);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const pagination = useSelector((state: ApplicationState) => state.Atendimentos.pagination);
  const loading = useSelector((state: ApplicationState) => state.Ocorrencia.loading);

  const [modalReabrirAtendimento, setModalReabrirAtendimento] = useState(false);

  const onFinish = async (values: any) => {
    const protocolo: number = propriedades?.protocolo;
    dispatch(loadRequestUpdate(protocolo, 'AA'));
    dispatch(sendMenssageRequest(protocolo, values.motivo));
    form.resetFields();
    setModalReabrirAtendimento(false);
    dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd as number, pagination));

    Swal.fire({
      title: `Atendimento finalizado com sucesso!`,
      html: '',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500,
    });
  };

  return (
    <>
      <Button
        data-cy="btnReabrirAtendimento"
        icon={<ArrowLeftOutlined />}
        type="primary"
        size="large"
        onClick={() => setModalReabrirAtendimento(true)}
        style={{ width: '100%' }}
        disabled={propriedades?.status !== 'AC' ? true : false}
      >
        Reabrir atendimento
      </Button>

      <Modal
        width={800}
        title=""
        visible={modalReabrirAtendimento}
        footer={[]}
        onCancel={() => setModalReabrirAtendimento(false)}
      >
        <StyleTitulo>
          <h1>
            <ExclamationCircleOutlined style={{ color: '#0FAC74' }} /> Reabertura do atendimento
          </h1>
        </StyleTitulo>
        <h2 className="themeSLA" style={{ fontSize: '16px' }}>
          Detalhes do atendimento
        </h2>
        <Detalhes>
          <div>
            <li>
              <div>Protocolo:</div>
              <div>#{('000000' + propriedades?.protocolo).slice(-6)}</div>
            </li>
            <li>
              <div>Parceiro:</div>
              <div>{maskCapitalized(propriedades?.parceiro)}</div>
            </li>
          </div>
          <div>
            <li>
              <div>Tipo de solicitação:</div>
              <div>{propriedades?.tipoSolicitacao}</div>
            </li>

            <li>
              <div>Urgência:</div>
              <div>{maskCapitalized(propriedades?.urgencia)}</div>
            </li>

            <li>
              <div>Nota(s):</div>
              <div>{propriedades?.listaNf}</div>
            </li>
          </div>
          <div>
            <li>
              <div>Data da abertura:</div>
              <div>{moment(propriedades?.dhAbertura).format('lll')}</div>
            </li>
            <li>
              <div>Data da conclusão:</div>
              <div>{moment(propriedades?.dhConclusao).format('lll')}</div>
            </li>
          </div>
        </Detalhes>
        <Form
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          wrapperCol={{ span: 24 }}
        >
          <Form.Item
            label="Motivo da reabertura"
            name="motivo"
            rules={[
              { required: true, message: 'Por favor digite o motivo da reabertura do atendimento' },
            ]}
          >
            <TextArea rows={7} placeholder="Digite aqui o motivo" />
          </Form.Item>

          <Form.Item style={{ alignItems: 'end' }}>
            <Space>
              <Button onClick={() => setModalReabrirAtendimento(false)}>Cancelar</Button>

              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{ backgroundColor: '#0FAC74', border: 'none' }}
              >
                Reabrir atendimento
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ModalReabrirAtendimento;
